/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPayLoadGetList } from 'app/common/interface'
import {
  DepartmentsEnum,
  EmploymentStatus,
  GenderTradeUnionEnum,
  PositionEnum
} from 'app/containers/TradeUnionMemberManagement/type'
import { ResponseType } from 'parkway-web-common'

export enum EthnicGroups {
  Kinh = 'Kinh',
  Tay = 'Tày',
  Thai = 'Thái',
  Muong = 'Mường',
  Hmong = "H'Mông",
  Khmer = 'Khmer',
  Nung = 'Nùng',
  Hoa = 'Hoa',
  Dao = 'Dao',
  GiaRai = 'Gia Rai',
  Ede = 'Ê Đê',
  BaNa = 'Ba Na',
  XoDang = 'Xơ Đăng',
  SanChay = 'Sán Chay',
  CoHo = 'Cơ Ho',
  Cham = 'Chăm',
  SanDiu = 'Sán Dìu',
  Hre = 'Hrê',
  Mnong = 'Mnông',
  RaGlai = 'Ra Glai',
  Tho = 'Thổ',
  CoTu = 'Cơ Tu',
  Churu = 'Churu',
  KhmerKrom = 'Khmer Krom',
  Lao = 'Lào',
  LaChi = 'La Chí',
  LaHa = 'La Ha',
  PuPeo = 'Pu Péo',
  PhuLa = 'Phù Lá',
  SiLa = 'Si La',
  Cong = 'Cống',
  ODu = 'Ơ Đu',
  Brau = 'Brâu',
  RoMam = 'Rơ Măm',
  HaNhi = 'Hà Nhì',
  ChuRu = 'Chu Ru',
  Khang = 'Kháng',
  Lu = 'Lự',
  LoLo = 'Lô Lô',
  BoY = 'Bố Y',
  Co = 'Cờ Ho',
  TaOi = 'Tà Ôi',
  ChoRo = 'Chơ Ro',
  KaTu = 'Ka Tu',
  BruVanKieu = 'Bru Vân Kiều',
  CoTuoi = 'Cơ Tu',
  Chut = 'Chứt',
  KhoMu = 'Khơ Mú',
  Mang = 'Mảng',
  PaThen = 'Pà Thẻn',
  SiLaD = 'Si La (D)',
  PuPeoD = 'Pu Péo (D)',
  DaoRed = 'Dao Đỏ',
  EdeBanar = 'Ê Đê (Ba Na)',

  // nước ngoài
  Forein = 'Người nước ngoài',
  // khác
  Other = 'Không rõ',
}

export interface IParamsGetTradeUnionMember extends IPayLoadGetList {
  search?: string
  gender?: GenderTradeUnionEnum
  page?: number
  limit?: number

  source?: number
  tinhTrangLamViec?: EmploymentStatus

  unitIds?: number[]
  activityIds?: number[]
  schoolIds?: number[]
  degreeIds?: number[]
}

export interface IParamsGetTradeUnionMemberHRM extends IPayLoadGetList {
  search?: string
  page?: number
  limit?: number
  unit?: DepartmentsEnum
  isSync?: number
}

export interface ITradeUnionMember {
  id?: string
  mql?: string
  last_name?: string
  first_name?: string
  gioiTinh?: string
  ngaySinh?: string
  nguyenQuan?: string
  cmnd?: string
  tenDonVi?: string
  tinhTrangLamViec?: string
  dienThoaiDiDong?: string
  email?: string
  danToc?: EthnicGroups
  tonGiao?: string
  noiOHienNay?: string
  hocHam?: AcademicRankEnum
  hocVi?: DegreeEnum
  tenPhanHieu?: UnitEnum
  ngayVaoUEH?: string
  ngayVaoCongDoan?: string
  soTheDoanVien?: string
  tinhTrangSinhHoat?: string
  chucVucongdoan?: string
  fullName?: string
  is_active?: boolean

  is_sync?: boolean
  isSync?: boolean
  valueCare?: string
  unit?: any

  school?: any
  activityEngagement?: any
  degree?: any

  ngayVaoDang?: string
}

export enum AcademicRankEnum {
  Professor = 'Giáo sư',
  AssociateProfessor = 'Phó Giáo sư',
}

export enum DegreeEnum {
  Bachelor = 'Cử nhân',
  Engineer = 'Kỹ sư',
  Doctor = 'Bác sĩ',
  Pharmacist = 'Dược sĩ',
  Master = 'Thạc sĩ',
  SpecialistDoctorI = 'Bác sĩ chuyên khoa I',
  PhD = 'Tiến sĩ',
  SpecialistDoctorII = 'Bác sĩ chuyên khoa II',
  DoctorOfScience = 'Tiến sĩ khoa học',
}

export enum UnitEnum {
  Business = 'Trường Kinh doanh',
  EconomicsLawAndPublicAdministration = 'Trường Kinh tế, Luật và Quản lý nhà nước',
  TechnologyAndDesign = 'Trường Công nghệ và Thiết kế',
  // Không thuộc công đoàn bộ phận
  Other = 'Không thuộc công đoàn bộ phận',
}

export type IResponseTradeUnionMemberList = ResponseType<{
  count: number
  rows: ITradeUnionMember[]
  total?: number
  totalIsSync?: number
}>

export interface IPayloadCreateTradeUnionMember {
  mql?: string
  last_name?: string
  first_name?: string
  gioiTinh?: string
  ngaySinh?: string
  nguyenQuan?: string
  cmnd?: string
  tenDonVi?: string
  tinhTrangLamViec?: string
  dienThoaiDiDong?: string
  email?: string
  danToc?: string
  tonGiao?: string
  noiOHienNay?: string
  hocHam?: AcademicRankEnum
  hocVi?: DegreeEnum
  tenPhanHieu?: UnitEnum
  ngayVaoUEH?: string
  ngayVaoCongDoan?: string
  soTheDoanVien?: string
  tinhTrangSinhHoat?: string
  chucVucongdoan?: string
  fullName?: string
  unitId?: string
  ngayVaoDang?: string

  isSync?: boolean
}

export interface IPayloadUpdateTradeUnionMember {
  id?: string
  mql?: string
  last_name?: string
  first_name?: string
  gioiTinh?: string
  ngaySinh?: string
  nguyenQuan?: string
  cmnd?: string
  tenDonVi?: string
  tinhTrangLamViec?: string
  dienThoaiDiDong?: string
  email?: string
  danToc?: string
  tonGiao?: string
  noiOHienNay?: string
  hocHam?: AcademicRankEnum
  hocVi?: DegreeEnum
  tenPhanHieu?: UnitEnum
  ngayVaoUEH?: string
  ngayVaoCongDoan?: string
  soTheDoanVien?: string
  tinhTrangSinhHoat?: string
  chucVucongdoan?: string
  fullName?: string
  unitId?: string
  ngayVaoDang?: string
}

export interface IRewardTum {
  id?: number
  name?: string
  description?: string
  link?: string
  link_name?: string
  year?: string
}

export interface IPayloadCreateRewardTum {
  trade_union_member_id?: string
  name?: string
  description?: string
  link?: string
  year?: string
  linkName?: string
}

export interface IPayloadUpdateRewardTum extends IPayloadCreateRewardTum {
  id?: number
}

export interface IParamDeleteRewardTum {
  id: number
}

export enum RewardTumStatus {
  WAITING = 'WAITING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
}

export interface IParamGetRewardTum {
  id: number
  status?: RewardTumStatus
}

export const initValuesFormCreateTum = {
  chucVucongdoan: [PositionEnum.DoanVien]
}